<template>
  <nav class="nav" v-if="isLoggedIn">
    <div class="showMobileBtn" @click="toggleMenu">
      <transition name="fade">
        <span v-if="showMobileMenu" key="true">
          <svg style="position: absolute; top: 15px; right: 10px;" width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_14_5)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 14.122L17.303 19.425C17.5844 19.7064 17.966 19.8645 18.364 19.8645C18.7619 19.8645 19.1436 19.7064 19.425 19.425C19.7064 19.1436 19.8645 18.7619 19.8645 18.364C19.8645 17.966 19.7064 17.5844 19.425 17.303L14.12 12L19.424 6.69699C19.5632 6.55766 19.6737 6.39226 19.749 6.21024C19.8244 6.02821 19.8631 5.83313 19.8631 5.63613C19.8631 5.43914 19.8242 5.24407 19.7488 5.06209C19.6733 4.8801 19.5628 4.71475 19.4235 4.57549C19.2841 4.43622 19.1187 4.32576 18.9367 4.25042C18.7547 4.17507 18.5596 4.13631 18.3626 4.13636C18.1656 4.13641 17.9706 4.17526 17.7886 4.25069C17.6066 4.32612 17.4412 4.43666 17.302 4.57599L12 9.87899L6.69697 4.57599C6.55867 4.43266 6.3932 4.31831 6.21024 4.23961C6.02727 4.16091 5.83046 4.11944 5.63129 4.11762C5.43212 4.11579 5.23459 4.15365 5.05021 4.22899C4.86583 4.30432 4.6983 4.41562 4.55739 4.55639C4.41649 4.69717 4.30503 4.86459 4.22952 5.0489C4.15401 5.23321 4.11597 5.43071 4.1176 5.62988C4.11924 5.82905 4.16053 6.02589 4.23905 6.20894C4.31758 6.39198 4.43177 6.55755 4.57497 6.69599L9.87997 12L4.57597 17.304C4.43277 17.4424 4.31858 17.608 4.24005 17.791C4.16153 17.9741 4.12024 18.1709 4.1186 18.3701C4.11697 18.5693 4.15501 18.7668 4.23052 18.9511C4.30603 19.1354 4.41749 19.3028 4.55839 19.4436C4.6993 19.5844 4.86683 19.6957 5.05121 19.771C5.23559 19.8463 5.43312 19.8842 5.63229 19.8824C5.83146 19.8805 6.02827 19.8391 6.21124 19.7604C6.3942 19.6817 6.55967 19.5673 6.69797 19.424L12 14.122Z" fill="white" /></g><defs><clipPath id="clip0_14_5"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>
        </span>
        <span v-else key="false">
          <svg style="position: absolute; top: 15px; right: 10px;" width="26" height="26" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.75 12.25H13.25M2.75 8.25H13.25M2.75 4.25H13.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </transition>
    </div>
    <ul id="navigation" class="nav__menu nav__primary" v-show="isMenuVisible" v-if="showMobileMenu">
      <li class="nav__item" v-if="hasRole('admin')">
        <a>Comenzi</a>
        <ul>
          <li class="nav__item"><router-link to="/orders">Listare</router-link></li>
          <li class="nav__item"><router-link to="/simple-orders">Comenzi simple</router-link></li>
          <li class="nav__item"><router-link to="/mixed-orders">Comenzi compuse</router-link></li>
          <li class="nav__item"><router-link to="/grouped-orders">Comenzi grupate</router-link></li>
          <li class="nav__item"><router-link to="/change-statuses-orders">Modificare stare comenzi</router-link></li>
          <li class="nav__item"><router-link to="/download-members">Download bază de date clienți</router-link></li>
        </ul>
      </li>
       <li class="nav__item" v-if="hasRole('admin')">
        <a>Retururi</a>
        <ul>
          <li class="nav__item"><router-link to="/returns">Listare</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a>Produse</a>
        <ul>
          <li class="nav__item"><router-link to="/new-product">Adauga produs</router-link></li>
          <li class="nav__item"><router-link to="/products">Listare produse</router-link></li>
          <li class="nav__item nav_submenu">
            <router-link to="/categories">Categorii website <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/new-category">Adauga categorie website</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/categories">Listare categorii website</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/categories-libraries">Categorii librării <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/new-category-library">Adaugă categorie librării</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/categories-libraries">Listare categorii librării</router-link></div>
            </div>
          </li>
          <li class="nav__item"><router-link to="/link-categories-libraries">Asociere categorii librării</router-link></li>
          <li class="nav__item"><router-link to="/import-products">Import produse</router-link></li>
          <li class="nav__item"><router-link to="/update-products">Actualizare produse</router-link></li>
          <li class="nav__item"><router-link to="/import-products-pdfs">Import pdf produse</router-link></li>
          <li class="nav__item"><router-link to="/import-list-prices-nexus">Import preturi nexus</router-link></li>
          <li class="nav__item"><router-link to="/generate-import-file">Genereaza fisier import produse</router-link></li>
          <li class="nav__item"><router-link to="/new-attribute">Adauga valori atribute</router-link></li>
          <li class="nav__item"><router-link to="/download-xml">Genereaza xml contabilitate</router-link></li>
          <li class="nav__item"><router-link to="/reviews">Reviewuri</router-link></li>
          <li class="nav__item"><router-link to="/prints">Comenzi print</router-link></li>
          <li class="nav__item"><router-link to="/footer-links">Linkuri footer</router-link></li>
          <li class="nav__item"><router-link to="/new-products">Noutati alte edituri</router-link></li>
          <li class="nav__item nav_submenu">
            <router-link to="/new-products">Audiobook-uri <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/audiobooks">Listare Audiobook-uri</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/add-audiobook">Adauga audiobook</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/new-products">Lansari viitoare <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/add-future-release">Adauga Lansare Viitoare</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/list-future-releases">Listare Lansari Viitoare</router-link></div>
            </div>
          </li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Membri</a>
        <ul>
          <li class="nav__item"><router-link to="/members">Listare</router-link></li>
          <li class="nav__item"><router-link to="/new-member">Adauga membru</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin') || hasRole('marketing')">
        <a class="nav__link">Marketing</a>
        <ul>
          <li class="nav__item"><router-link to="/daily-offer" class="nav__link">Ofertele zilei</router-link></li>
          <li class="nav__item"><router-link to="/vouchers" class="nav__link">Vouchere</router-link></li>
          <li class="nav__item"><router-link to="/new-banner">Adauga banner</router-link></li>
          <li class="nav__item"><router-link to="/banners">Listare bannere</router-link></li>
          <li class="nav__item"><router-link to="/new-gift">Adauga bonus</router-link></li>
          <li class="nav__item"><router-link to="/new-bonus">Adauga campanie "n+1"</router-link></li>
          <li class="nav__item"><router-link to="/gifts">Listare bonusuri</router-link></li>
          <li class="nav__item"><router-link to="/email-bonuses">Bonusuri pe email</router-link></li>
          <li class="nav__item"><router-link to="/new-slider">Adauga slider</router-link></li>
          <li class="nav__item"><router-link to="/sliders">Listare slidere</router-link></li>
          <li class="nav__item"><router-link to="/marketing/campaigns">Campanii marketing</router-link></li>
          <li class="nav__item"><router-link to="/marketing/cross-sale-campaigns">Campanii cross sale</router-link></li>
          <li class="nav__item"><router-link to="/marketing/notification-lists">Notificari</router-link></li>
          <li class="nav__item"><router-link to="/marketing/qr-code">Generare cod QR</router-link></li>
          <li class="nav__item nav_submenu">
            <router-link to="/new-products">Campanii Influenceri <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/fb-authors-campaigns">Campanii</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/fb-authors">Autori/Influenceri</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/colaborari-permanente">Colaborari</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/promotional-packages">Pachete de promovare</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/new-products">Campanii Marketing <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/popup-campaigns">Campanii Pop-up</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/gradual-campaign">Reduceri în valuri</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/epic-offer-campaign">Oferta Epica</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/marketing/wow-bestseller-campaign">WOW Bestseller</router-link></div>
            </div>
          </li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin') || hasRole('reports')">
        <a>Rapoarte</a>
        <ul>
          <li class="nav__item"><router-link to="/graph-reports">Grafic Vanzari</router-link></li>
          <li class="nav__item"><router-link to="/reports-salesbydate">Rapoarte pe data</router-link></li>
          <li class="nav__item"><router-link to="/reports-salesbyproducts">Rapoarte pe produse</router-link></li>
          <li class="nav__item"><router-link to="/author-reports">Situatie autori</router-link></li>
          <li class="nav__item"><router-link to="/marketing-costs">Costuri de marketing</router-link></li>
          <li class="nav__item"><router-link to="/google-reports">Rapoarte google</router-link></li>
          <li class="nav__item"><router-link to="/sales-audiobooks">Vanzari audiobook-uri</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a>Management</a>
        <ul>
          <li class="nav__item"><router-link to="/management-exportorders">Export comenzi</router-link></li>
          <li class="nav__item"><router-link to="/management-currentproductprices">Prețuri produse curente</router-link></li>
          <li class="nav__item"><router-link to="/management-orderssingleproducts">Prețuri produse singulare în comenzi</router-link></li>
          <li class="nav__item"><router-link to="/management-orderspackages">Prețuri produse în pachete în comenzi</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a>Landing-uri</a>
        <ul>
          <li class="nav__item"><router-link to="/landings" class="nav__link">Landing-uri</router-link></li>
          <li class="nav__item"><router-link to="/latest-products" class="nav__link">Ultimele aparitii</router-link></li>
          <li class="nav__item"><router-link to="/landings-launches" class="nav__link">Landing-uri de lansare</router-link></li>
          <li class="nav__item"><router-link to="/bf-landing" class="nav__link">Landing-black friday</router-link></li>
          <li class="nav__item"><router-link to="/category-landings" class="nav__link">Landing-uri pe categorii</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Depozit</a>
        <ul>
          <li class="nav__item"><router-link to="/shelves">Rafturi</router-link></li>
          <li class="nav__item"><router-link to="/boxes">Cutii</router-link></li>
          <li class="nav__item"><router-link to="/stock-reports">Analiza stocuri</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/critical-stock">Stocuri Critice</router-link></li>
          <li class="nav__item"><router-link to="/searches">Cautari</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/users">Utilizatori aplicație</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/add-user">Adaugă utilizator</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/reports">Rapoarte</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/inventory">Inventar</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/pending-stock">Stoc intermediar</router-link></li>
          <li class="nav__item"><router-link to="/warehouse/documente-nexus">Documente Nexus (NIR-uri)</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Distribuitori</a>
        <ul>
          <li class="nav__item" style="min-width: 213px;">
            <router-link to="/distribuitori">Sumar</router-link>
            <router-link to="/distribuitori/import-raport-vanzari">Import vânzări</router-link>
            <router-link to="/distribuitori/documente">Documente</router-link>
            <router-link to="/distribuitori/fisa-client">Fisa Client</router-link>
            <router-link to="/distribuitori/incasari">Inacasari</router-link>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/distribuitori/comenzi">Comenzi <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/retururi">Retururi</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/comenzi">Listare Comenzi</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/adauga-comanda">Adaugă Comandă</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/distribuitori/clienti">Clienți <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/clienti">Listare Clienți</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/adauga-client">Adaugă Client</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <a class="nav__link">Rapoarte <i class="icon-arrow_right" /></a>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/raport-sold">Raport sold</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/raport-vanzari-distribuitori">Raport vanzari</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/raport-stocuri">Raport stocuri</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/raport-vanzari-dupa-coduri-de-bare">Raport vanzari dupa cod de bare</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/stock-notices">Raport Stoc Avize</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <a class="nav__link">Produse <i class="icon-arrow_right" /></a>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/produse">Cauta produse in documente</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/produse-noi-necomandate">Produse noi necomandate</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/produse-isbn">ISBN Produse</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/distribuitori/export-produse">Export Produse</router-link></div>
            </div>
          </li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Furnizori</a>
        <ul>
          <li class="nav__item"><router-link to="/furnizori/adauga-furnizor">Adaugă furnizor</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/lista-furnizori">Listă furnizori</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/comenzi">Comenzi</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/reguli-pret-dinamic">Reguli preț dinamic</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/raport">Raport</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/raport-vanzari">Raport vânzări</router-link></li>
          <li class="nav__item"><router-link to="/furnizori/import-facturi-plata-avans">Import facturi plată avans</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Vânzări</a>
        <ul>
          <li class="nav__item"><router-link to="/vanzari/agenti" class="nav__link">Agenți</router-link></li>
          <li class="nav__item"><router-link to="/vanzari/rapoarte-activitate" class="nav__link">Rapoarte activitate</router-link></li>
          <li class="nav__item"><router-link to="/vanzari/rapoarte-nivel-vanzari" class="nav__link">Rapoarte nivel vanzari</router-link></li>
          <li class="nav__item"><router-link to="/vanzari/rapoarte-progres-vizita" class="nav__link">Rapoarte progres vizita</router-link></li>
          <li class="nav__item"><router-link to="/vanzari/targuri/" class="nav__link">Târguri și Evenimente</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin') || hasRole('librarymanager')">
        <a class="nav__link">Librării</a>
        <ul>
          <li class="nav__item"><router-link to="/librarii/analiza-vanzari/" class="nav__link">Analiză vânzări</router-link></li>
          <li class="nav__item nav_submenu">
            <router-link to="/librarii/comenzi-furnizori/">Comenzi furnizori <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/librarii/comenzi-furnizori/">Listare Comenzi</router-link></div>
              <div class="nav_submenu_wrapper_item"><router-link to="/librarii/adauga-comanda/">Adaugă Comandă</router-link></div>
            </div>
          </li>
          <li class="nav__item nav_submenu">
            <router-link to="/librarii/glovo/export-catalog-glovo/">Glovo <i class="icon-arrow_right" /></router-link>
            <div class="nav_submenu_wrapper">
              <div class="nav_submenu_wrapper_item"><router-link to="/librarii/glovo/export-catalog-glovo/">Export catalog produse </router-link></div>
            </div>
          </li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Contabilitate</a>
        <ul>
          <li class="nav__item"><router-link to="/contabilitate/generare-e-factura">Generare e-factura</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-facturi">Raport facturi</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-receptie-marfa">Raport recepție marfă</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-payu">Raport incasari PayU</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-emag">Raport incasari Emag</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-altex">Raport incasari Altex</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-awb">Raport incasari dupa AWB</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-2perf">Raport comenzi 2Performant</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/verificare-lista-awb">Verificare lista AWB-uri</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-miscari-stocuri">Raport mișcări stocuri</router-link></li>
          <li class="nav__item"><router-link to="/contabilitate/raport-verificare-facturi">Raport verificare facturi</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Redacție</a>
        <ul>
          <li class="nav__item"><router-link to="/redactie/achizitii-titluri/">Achiziții titluri</router-link></li>
          <li class="nav__item"><router-link to="/redactie/adauga-titlu-achizitionat/">Adaugă achiziție titlu</router-link></li>
        </ul>
      </li>
      <li class="nav__item" v-if="hasRole('admin')">
        <a class="nav__link">Setări</a>
        <ul>
          <li class="nav__item"><router-link to="/cache">Cache</router-link></li>
          <li class="nav__item"><router-link to="/settings">Setări campanii</router-link></li>
          <li class="nav__item"><router-link to="/settings/search">Setări search</router-link></li>
        </ul>
      </li>
    </ul>
    <ul id="navigation" class="nav__menu nav_search_wrapper">
      <li class="nav__item nav__search" v-show="isMenuVisible">
        <autocomplete :url="baseAdminUrl + 'product/search'" anchor="title" label="writer" :on-select="getData" :onShouldRenderChild="renderChild" name="term" id="autocomplete-v" :debounce="500"
          :v-model="term" :onInput="storeTerm" style="float: left; z-index: 9;">
        </autocomplete>
        <button id="submit-btn" @click="click_select" class="btn btn--white">Cauta</button>
      </li>
      <li class="nav__item">
        <a>Bine ai venit, {{ getFirstName }}</a>
        <ul>
          <li class="nav__item"><a @click="logout">Logout</a></li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import Autocomplete from "vue2-autocomplete-js";
import axios from "axios";

export default {
  components: {
    Autocomplete,
  },
  data() {
    return {
      windowInnerWidth: window.innerWidth,
      showMobileMenu: true,
      showMobileMenuButon: false,
      term: "",
      isMenuVisible: true,
       userRoles: []
    };
  },
  mounted() {
    this.userRoles = JSON.parse(localStorage.getItem('roles') || '[]');
    this.CanMenuBeVisible();
    // Get the input field
    var input = document.getElementById("autocomplete-v");

    // Execute a function when the user releases a key on the keyboard
    input.addEventListener("keydown", function (event) {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        // Trigger the button element with a click
        document.getElementById("submit-btn").click();
      }
    });

    window.innerWidth < 900 ? this.showMobileMenu = false : this.showMobileMenu = true
  },
  methods: {
    hasRole(role) {
      try {
        return this.userRoles.includes(role.toLowerCase());
      } catch {
        return false;
      }
    },
    CanMenuBeVisible() {
      if (localStorage.getItem('redirect') != null) {
        this.isMenuVisible = false;
      } else {
        this.isMenuVisible = true;
      }
    },
    downloadContab() {
      axios
        .get(this.baseAdminUrl + "product/exportContabXML", {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "nomenclator.xml";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },
    storeTerm(elem) {
      this.term = elem;
    },
    click_select() {
      window.location.href = "/products/" + this.term;
    },
    renderChild(data) {
      return `${data.productId},${data.title},${data.price} Lei`;
    },
    getData(element) {
      window.location.href = "/product/" + element.productId;
    },
    logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("email");
      localStorage.removeItem("redirect");
      localStorage.removeItem("roles");
      window.location.href = "/";
    },
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
    openSubmenu(id) {
      this.productsNestedMenu = this.productsNestedMenu.map(elm => ({
        ...elm,
        isOpen: elm.id === id
      }));
      this.marketingNestedMenu = this.marketingNestedMenu.map(elm => ({
        ...elm,
        isOpen: elm.id === id
      }));
      this.distributionNestedMenu = this.distributionNestedMenu.map(elm => ({
        ...elm,
        isOpen: elm.id === id
      }));
    },
    closeSubmenu() {
      this.productsNestedMenu = this.productsNestedMenu.map(elm => ({
        ...elm,
        isOpen: false
      }));
      this.marketingNestedMenu = this.marketingNestedMenu.map(elm => ({
        ...elm,
        isOpen: false
      }));
      this.distributionNestedMenu = this.distributionNestedMenu.map(elm => ({
        ...elm,
        isOpen: false
      }));
    }
  },
  computed: {}
};
</script>

<style scoped>
.nav_submenu {
  transition: all 300ms ease;
  height: 50px !important;
  position: relative;
}

.nav_submenu a {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav_submenu:hover > .nav_submenu_wrapper {
  display: block;
  position: relative;
}

.nav_submenu_wrapper {
  display: none;
  position: absolute;
  top: 0;
}

.nav_submenu_wrapper_item {
  transition: all 300ms ease;
  transform: translate(100%, -100%);
  position: relative;
  background: #075368;
  padding: 4px;
}

/* Navigation */
#navigation {
  list-style: none;
  font-family: "Century Gothic", Verdana, Arial, Sans-Serif;
  margin: 0;
  padding: 0;
  font-size: 0.8em;
  color: white;
  font-size: 1.4rem;
}

/* CSS for each Parent Item */
#navigation li {
  position: relative;
}

#navigation li.last-child {
  float: right;
}

#navigation li a {
  display: block;
  padding: 4px;
  text-decoration: none;
  color: #fff;
  font-size: 12px;
}

/* Change background color and font color
of parent items when mouse hover */
#navigation li:hover a,
#navigation li a:hover {
  color: #fff;
}

#navigation ul {
  display: none;
}

/* Each Child Item will be visible if mouse hover */
#navigation li:hover ul {
  display: block;
  position: absolute;
  background-color: #075368;
  left: 0;
  width: auto;
}

#navigation li:hover .mobile_chevron {
  transform: rotate(180deg);
  transition: all 300ms ease;
}

#navigation ul {
  list-style: none;
  margin: 0;
  padding: 8px 8px;
  z-index: 100;
}

#navigation ul li {
  margin: 0;
  padding: 0;
  width: auto;
  height: auto;
  color: #fff;
  display: block;
}

#navigation li:hover ul li a,
#navigation ul li a {
  display: flex;
  width: 100%;
  white-space: nowrap;
  color: #fff;
  background: none;
  height: 5rem;
  align-items: center;
}

#navigation li:hover ul li a:hover,
#navigation ul li a:hover {
  background-color: #0990b6;
  color: #000;
}

.autocomplete-list ul {
  max-height: 60rem !important;
  overflow-y: scroll;
  padding: unset !important;
}

.autocomplete-list ul li {
  margin: unset !important;
  padding: unset;
}

.autocomplete-list ul li a {
  font-size: 1.4rem !important;
  width: unset !important;
  height: unset !important;
  padding: 1rem !important;
  margin: unset !important;
}

.showMobileBtn {
  display: none;
}

.mobile_chevron {
  display: none;
}

.icon-arrow_right {
  margin-left: 4px;
}

@media screen and (max-width: 900px) {
  .nav_submenu {
    height: auto !important;

  }

  .nav_submenu_wrapper_item {
    transform: translate(0, 0);
    position: static;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
  }

  .showMobileBtn {
    display: block;
    position: absolute;
    font-size: 30px;
    color: #fff;
    z-index: 9999;
    top: 20px;
    right: 10px;
  }

  .mobile_chevron {
    display: inline-block;
    transition: all 300ms ease;
  }

  .nav {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding: 6px;
  }

  .nav__primary {
    flex-direction: column;
  }

  .nav_search_wrapper {
    flex-direction: column-reverse;
  }

  .nav__item {
    padding: 0 4px;
  }

  #navigation li:hover ul li a,
  #navigation ul li a {
    height: 2.5rem;
  }

  .nav__search {
    margin: 0 0 12px 0;
  }

  #navigation li:hover ul {
    display: block;
    position: static;
    background-color: #075368;
    left: 0;
    width: auto;
  }
}
</style>